import script from "./UITitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./UITitle.vue?vue&type=script&setup=true&lang=ts"

import "./UITitle.vue?vue&type=style&index=0&id=54e5351c&lang=css"

const __exports__ = script;

export default __exports__